// extracted by mini-css-extract-plugin
export var card = "card-module--card--656f0";
export var ripple = "card-module--ripple--2780f";
export var rippleEffect = "card-module--rippleEffect--d7ec8";
export var rippleReverse = "card-module--rippleReverse--f1e38";
export var title = "card-module--title--dc06d";